/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateUploadedFilePayloadDto,
  ErrorResponse,
  UploadedFileWithSasTokenResponseDto,
} from '../models/index';
import {
    CreateUploadedFilePayloadDtoFromJSON,
    CreateUploadedFilePayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    UploadedFileWithSasTokenResponseDtoFromJSON,
    UploadedFileWithSasTokenResponseDtoToJSON,
} from '../models/index';

export interface CreateUploadedFileRequest {
    createUploadedFilePayloadDto: CreateUploadedFilePayloadDto;
}

/**
 * 
 */
export class UploadedFileApi extends runtime.BaseAPI {

    /**
     * Create uploaded file
     */
    async createUploadedFileRaw(requestParameters: CreateUploadedFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadedFileWithSasTokenResponseDto>> {
        if (requestParameters['createUploadedFilePayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createUploadedFilePayloadDto',
                'Required parameter "createUploadedFilePayloadDto" was null or undefined when calling createUploadedFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/uploaded-file/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUploadedFilePayloadDtoToJSON(requestParameters['createUploadedFilePayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadedFileWithSasTokenResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create uploaded file
     */
    async createUploadedFile(requestParameters: CreateUploadedFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadedFileWithSasTokenResponseDto> {
        const response = await this.createUploadedFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
